<div class="ra-modal">
  <!-- Header -->
  <div class="ra-modal__header">
    <div>
      <p class="ra-modal__step-label">NEW REPORT · STEP {{ step }} OF {{ stepTotal }}</p>
      <h2 class="ra-modal__title">{{ stepTitle }}</h2>
    </div>
    <button type="button" class="ra-modal__close-btn" (click)="close()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Progress dots -->
  <div class="ra-modal__progress">
    <span class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 1"></span>
    <span class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 2"></span>
    <span *ngIf="typeHasFilters" class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 3"></span>
  </div>

  <!-- Body -->
  <div class="ra-modal__body">

    <!-- STEP 1: Report type -->
    <ng-container *ngIf="step === 1">
      <p class="ra-modal__hint">Choose the report you want to generate. Each type pulls from real Snowflake catalogs.</p>
      <div *ngIf="loadingReportTypes" class="ra-modal__type-loading">
        <span class="ra-table-card__spinner"></span>
      </div>
      <div *ngIf="!loadingReportTypes" class="ra-modal__type-list">
        <button
          *ngFor="let t of reportTypes"
          type="button"
          class="ra-modal__type-card"
          [class.ra-modal__type-card--selected]="form.type === t.name"
          (click)="form.type = t.name"
        >
          <span class="ra-modal__type-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M5 21V5a2 2 0 0 1 2-2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
              <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="ra-modal__type-text">
            <span class="ra-modal__type-name">{{ t.name }}</span>
          </span>
          <span class="ra-modal__radio" [class.ra-modal__radio--selected]="form.type === t.name">
            <span class="ra-modal__radio-dot"></span>
          </span>
        </button>
      </div>
    </ng-container>

    <!-- STEP 2: Base fields -->
    <ng-container *ngIf="step === 2">
      <p class="ra-modal__hint">Select values from the catalog. Type to search inside any field.</p>
      <div class="ra-modal__fields">
        <one-select
          label="maker"
          [dataSource]="makersDataSource"
          [config]="makerSelectConfig"
          (selectionChanged)="onMakerChange($event)"
        ></one-select>

        <div class="ra-modal__fields-group">
          <div class="ra-modal__fields-group-label">Pay period</div>
          <div class="ra-modal__fields-row">
            <app-search-select
              label="Pay month"
              [required]="true"
              [value]="form.month"
              placeholder="Month…"
              searchPlaceholder="Search month…"
              [options]="months"
              (valueChange)="form.month = $event"
            ></app-search-select>

            <app-search-select
              label="Pay year"
              [required]="true"
              [value]="form.year"
              placeholder="Year…"
              searchPlaceholder="Search year…"
              [options]="years"
              (valueChange)="form.year = $event"
            ></app-search-select>
          </div>
        </div>

        <app-search-select
          label="Language"
          [required]="true"
          [value]="form.language"
          placeholder="Select…"
          searchPlaceholder="Search language…"
          [options]="languages"
          (valueChange)="form.language = $event"
        ></app-search-select>

        <div *ngIf="isCampaignReport" class="ra-modal__text-field">
          <label class="ra-modal__text-field-label">
            Campaign tag <span class="ra-modal__required">*</span>
          </label>
          <input
            type="text"
            class="ra-modal__text-field-input"
            placeholder="e.g. PSCo_JBP-Nov/25_BlackFriday"
            [value]="form.campaignTag"
            (input)="form.campaignTag = $event.target.value"
          />
        </div>
      </div>
    </ng-container>

    <!-- STEP 3: Optional filters -->
    <ng-container *ngIf="step === 3">
      <div class="ra-modal__optional-badge">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <path d="M12 11v5M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        All filters are optional — only fill in what you need.
      </div>
      <div class="ra-modal__fields">
        <div class="ra-modal__axis-group">
          <span class="ra-modal__axis-label">Segmentation axis</span>
          <div class="ra-modal__axis-tabs">
            <button
              *ngFor="let ax of axisList"
              type="button"
              class="ra-modal__axis-tab"
              [class.ra-modal__axis-tab--active]="form.axis === ax.key"
              (click)="onAxisChange(ax.key)"
            >{{ ax.label }}</button>
          </div>
          <ng-container *ngIf="form.axis === 'segment'">
            <app-search-select
              label="Filter by category"
              [required]="false"
              [value]="form.axisCategory"
              placeholder="All categories"
              searchPlaceholder="Search category…"
              [disabled]="loadingCategories"
              [options]="categoryOptions"
              (valueChange)="onAxisCategoryChange($event)"
            ></app-search-select>
          </ng-container>

          <app-search-select
            *ngIf="form.axis"
            [label]="''"
            [required]="false"
            [value]="form.axisValue"
            [placeholder]="activeAxisPlaceholder"
            [searchPlaceholder]="'Search ' + form.axis + '…'"
            [disabled]="activeAxisLoading"
            [options]="activeAxisOptions"
            (valueChange)="form.axisValue = $event"
          ></app-search-select>
          <p *ngIf="!form.axis" class="ra-modal__axis-hint">Choose an axis to filter by a specific value.</p>
        </div>

        <app-search-select
          label="Trademark"
          [required]="false"
          [value]="form.trademark"
          placeholder="All trademarks"
          searchPlaceholder="Search trademark…"
          [disabled]="loadingTrademarks || !form.maker"
          [options]="trademarkOptions"
          (valueChange)="form.trademark = $event"
        ></app-search-select>

        <div class="ra-modal__fields-group">
          <span class="ra-modal__axis-label">Retailer</span>
          <div class="ra-modal__clearable-select">
          <one-select
            label="All retailers"
            [dataSource]="retailersDataSource"
            [config]="retailerSelectConfig"
            (selectionChanged)="onRetailerChange($event)"
          ></one-select>
          <button
            *ngIf="selectedRetailer"
            type="button"
            class="ra-modal__clearable-select-btn"
            title="Clear"
            (click)="clearRetailer()"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          </div>
        </div>

        <app-search-select
          label="Vertical"
          [required]="false"
          [value]="form.vertical"
          placeholder="All verticals"
          searchPlaceholder="Search vertical…"
          [disabled]="loadingVerticals"
          [options]="verticalOptions"
          (valueChange)="form.vertical = $event"
        ></app-search-select>

        <div class="ra-modal__fields-group">
          <div class="ra-modal__fields-group-label">Start period</div>
          <div class="ra-modal__fields-row">
            <app-search-select
              label="Start month"
              [required]="!!form.startYear"
              [value]="form.startMonth"
              placeholder="Month…"
              searchPlaceholder="Search month…"
              [options]="months"
              (valueChange)="form.startMonth = $event"
            ></app-search-select>

            <app-search-select
              label="Start year"
              [required]="!!form.startMonth"
              [value]="form.startYear"
              placeholder="Year…"
              searchPlaceholder="Search year…"
              [options]="years"
              (valueChange)="form.startYear = $event"
            ></app-search-select>
          </div>
          <p *ngIf="!startPeriodValid" class="ra-modal__field-error">Both month and year are required together.</p>
        </div>
      </div>
    </ng-container>

  </div>

  <!-- Footer -->
  <div class="ra-modal__footer">
    <span class="ra-modal__format-hint">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
        <path d="M5 21V5a2 2 0 0 1 2-2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      </svg>
      Output format: PPTX
    </span>

    <button *ngIf="canGoBack" type="button" class="ra-modal__btn ra-modal__btn--secondary" (click)="back()">Back</button>

    <button
      *ngIf="showNext"
      type="button"
      class="ra-modal__btn ra-modal__btn--primary"
      [disabled]="!nextEnabled"
      (click)="next()"
    >Next</button>

    <button
      *ngIf="showGenerate"
      type="button"
      class="ra-modal__btn ra-modal__btn--primary"
      [disabled]="!generateEnabled || submitting"
      (click)="submit()"
    >{{ submitting ? 'Generating…' : 'Generate report' }}</button>
  </div>
</div>
